import { NamedEntityDto } from './named.dto';

export class AppearanceChangeDto extends NamedEntityDto {}
